<template>
  <el-dialog
    :title="$t('text.sendMessage')"
    :visible="show"
    @close="closeDialog"
    :close-on-click-modal="false"
  >
    <el-card
      class="box-card"
      shadow="never"
      style="margin-bottom: 10px"
      v-for="(item, index) in messageTemplates"
      :key="index"
    >
      <div slot="header" class="clearfix">
        <span style="font-weight: bold">{{ $t('text.templateIndex', { index: index + 1 }) }}</span>
        <span style="float: right">
          <el-button type="primary" size="mini" @click="startEdit(item)" v-if="item.isEditMode === false">{{ $t('text.edit') }}</el-button>
          <el-button type="primary" size="mini" @click="confirmEdit(item)" v-if="item.isEditMode === true">{{ $t('text.save') }}</el-button>
          <el-button type="primary" size="mini" @click="cancelEdit(item)" v-if="item.isEditMode === true">{{ $t('text.cancel') }}</el-button>
          <el-button type="primary" size="mini" @click="handleFill(item)" v-if="item.isEditMode === false">{{ $t('text.fillIn') }}</el-button>
        </span>
      </div>
      <div class="cardContent">
        <div class="messageItem">
          <el-tag size="mini" type="info">{{ $t('message.messageTitle') }}</el-tag>
          <div class="messageInfo" v-if="item.isEditMode === false">{{ item.title }}</div>
          <el-input class="messageInfo" v-model="item.title" v-if="item.isEditMode===true"></el-input>
        </div>
        <div class="messageItem">
          <el-tag size="mini" type="info">{{ $t('message.messageContent') }}</el-tag>
          <div class="messageInfo" v-if="item.isEditMode === false">{{ item.content }}</div>
          <el-input class="messageInfo" v-model="item.content" v-if="item.isEditMode===true"></el-input>
        </div>
      </div>
    </el-card>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span style="font-weight: bold">{{ $t('text.customMessage') }}</span>
      </div>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="140px"
        style="margin-top: 20px"
      >
        <el-form-item :label="$t('text.messageTitle')" prop="title">
          <el-input
            v-model="form.title"
            :placeholder="$t('message.inputMessageTitle')"
            maxlength="15"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.messageContent')" prop="content">
          <el-input
            v-model="form.content"
            :placeholder="$t('message.inputMessageContent')"
            maxlength="2000"
            type="textarea"
            :autosize="{ minRows: 2 }"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submit"
        >{{ $t('text.confirm') }}</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    show: Boolean,
    id: Array,
  },
  data() {
    return {
      dialogShow: this.show,
      form: {
        title: '',
        content: '',
      },
      rules: {
        title: [
          { required: true, message: this.$t('message.inputMessageTitle'), trigger: 'blur' },
          { min: 5, max: 15, message: this.$t('message.messageTitleLengthError'), trigger: 'blur' },
        ],
        content: [
          { required: true, message: this.$t('message.inputMessageContent'), trigger: 'blur' },
          {
            min: 10,
            max: 2000,
            message: this.$t('message.messageContentLengthError'),
            trigger: 'blur',
          },
        ],
      },
      messageTemplates: [],
      submitLoading: false,
      temporaryMessage: null,
    }
  },
  methods: {
    closeDialog() {
      this.submitLoading = false
      this.dialogShow = false
      this.$refs['form'].resetFields() //关闭的时候重置表单
      this.$emit('update:show', false)
    },
    handleFill(item) {
      this.form = Object.assign({}, item)
      this.$refs['form'].resetFields()
    },
    startEdit(item) {
      this.temporaryMessage = {
        templateId: item.templateId,
        title: item.title,
        content: item.content
      }
      item.isEditMode = true;
    },
    confirmEdit(item) {
      const param = {
        templateId: item.templateId,
        title: item.title,
        content: item.content
      }

      this.$axios
          .put('/notice/telegramMessageTemplate', param)
          .then(res => {
            if (res.code === 200) {
              this.$notify.success({
                title: this.$t('text.prompt').toString(),
                message: res.msg
              });
              return true;
            } else {
              this.$notify.error({
                title: this.$t('text.prompt').toString(),
                message: res.msg
              });
              return false;
            }
          }).catch(() => {
      });

      item.isEditMode = false;
    },
    cancelEdit(item) {
      item.title = this.temporaryMessage.title;
      item.content = this.temporaryMessage.content;
      item.isEditMode = false;
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.submitLoading = true

          var ids = '';
          this.id.forEach((v, i) => {
            ids = ids + v + ",";
          });

          const params = {
            title: this.form.title,
            content: this.form.content,
            groups: ids,
          }
          this.axios
            .post('/notice/sendTgMsg', params)
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: 'success',
                })
                this.closeDialog()
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                })
                this.submitLoading = false
              }
            })
            .catch(err => {
              this.submitLoading = false
            })
        }
      })
    },
  },
  created() {
    this.$axios
        .get("/notice/telegramMessageTemplate", {params: {}})
        .then((res) => {
          this.messageTemplates = res.data;
          this.messageTemplates.map((item) => {
            this.$set(item, 'isEditMode', false);
          })
        });
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__header {
  padding: 6px 10px;
  .clearfix {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 28px;
  }
}
.messageItem {
  display: flex;
  line-height: 22px;
  .messageInfo {
    flex: 1;
  }
}
::v-deep .el-card__body {
  padding: 2px 10px;
}
::v-deep .el-dialog__body {
  padding: 10px 20px;
}
</style>